// src/web/MeetingPage.jsx

import { Link } from "react-router-dom";
import PageTracker from '../../components/tracking/PageTracker';
import ScrollTracker from '../../components/tracking/ScrollTracker';

const MeetingPage = () => {
  return (
    <div className="meet-page">
      <PageTracker pageName="MeetingPage" />

      <div className="meet-wrapper">
         <div className="meet-card">
              <h2>Schedule a meeting</h2>
        
              <p>
                Schedule a meeting to explore your goals, context, and possible
                implementation scope — from Perceptual Skill Development and
                Institutional Programs to Perceptual Data Annotation,
                Perceptual Research Infrastructure, and voice technology
                projects.
              </p>
        
              <p className="meet-context">
                No commitment — just a conversation to understand your needs,
                constraints, and fit.
              </p>

              <p className="meet-context">
                If you need more context first, you can review{" "}
                <Link to="/services">Services</Link>,{" "}
                <Link to="/perceptual-skill-development">Perceptual Skill Development</Link>, or{" "}
                <Link to="/institutional-programs">Institutional Programs</Link>.
              </p>
        
              <p className="meet-instruction">
                Choose a time that works best for you.
              </p>
        
              <div className="meet-calendar">
                <iframe
                  src="https://cal.eu/all-voiced/meet?theme=light"
                  title="Schedule a meeting"
                />
              </div>
        
              <p className="meet-note">
                After booking, you will receive a confirmation email with the meeting details. 
                If it doesn’t appear in your inbox, please check your spam or other folders (sent from hello@cal.com).
              </p>
        
              <p className="meet-note">
                By submitting this form you agree to our{" "}
                <Link to="/privacy-policy">Privacy Policy</Link>.
              </p>
            </div>
      </div>

      <ScrollTracker pageName="MeetingPage" />
    </div>
  );
};

export default MeetingPage;
